import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getMerchantRoutes, getRouteConfigParams } from 'services/insightsAI';
import { RouteConfig, RouteConfigList } from './types';

export const useRouteConfigParams = (routeId: number): RouteConfig => {
  const [data, setData] = useState<RouteConfig>({} as RouteConfig);

  useEffect(() => {
    if (typeof routeId === 'number') {
      getRouteConfigParams(routeId).then((response: RouteConfig) =>
        setData(response),
      );
    }
  }, [routeId]);

  return data;
};

export const useFetchMerchantRouteConfigs = (): {
  loading: boolean;
  merchantRouteConfigs: RouteConfigList;
} => {
  const [merchantRouteConfigs, setMerchantRouteConfigs] = useState<
    RouteConfigList
  >([] as RouteConfigList);

  const [searchParams] = useSearchParams();
  const env = searchParams.get('env') || '';

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getMerchantRoutes()
      .then((response: RouteConfigList) => {
        setLoading(false);
        setMerchantRouteConfigs(response);
      })
      .catch(e => setLoading(false));
  }, [env]);

  return { loading, merchantRouteConfigs };
};
